// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_linhaTitulo__Hp35d {
    border-bottom: 0.1rem solid #0f2047 !important;
    margin-left: 40px !important;
    width: 80px !important;
    margin-top: -16px !important;
  }
  
  .styles_linhaTituloPopup__pk1Za {
    border-bottom: 0.2rem solid #0f2047 !important;
    margin-left: 40px !important;
    width: 80px !important;
    margin-top: 0px !important;
    padding-top: 0px !important;
  }
  
  .styles_tituloContainer__DDrMr {
    display: flex !important;
    align-items: center !important;
    margin-left: 40px !important;
    margin-top: -28px !important;
  }
  
  .styles_titulo__KESZq {
    font-size: 44px !important;
    color: #0f2047 !important;
    font-family: "Abhaya Libre" !important;
  }
  
  .styles_iconeTitulo__T4EYK {
    font-size: 40px !important;
    color: #0f2047 !important;
    margin-left: 12px !important;
    margin-right: 12px !important;
    margin-top: -8px !important;
  }
  
  .styles_iconeTituloPopup__g0LKR {
    font-size: 40px !important;
    color: #0f2047 !important;
    margin-top: -8px !important;
  }
  
  .styles_botaoContainer__NX6Tk {
    display: flex !important;
    align-items: center !important;
    margin-left: 40px !important;
  }
  
  .styles_botaoNovo__j3\\+MO {
    width: 120px !important;
    background-color: #0f2047 !important;
    color: #ffffff !important;
    border-color: #ffffff !important;
    border-width: 1px !important;
    border-style: solid !important;
    font-family: "Inter" !important;
    font-size: 16px !important;
    margin-top: 12px !important;
    margin-left: 20% !important;
    border-radius: 8px !important;
    transition: all 0.3s ease !important;
    text-transform: capitalize !important;
    height: 36px !important;
  }
  
  .styles_botaoNovo__j3\\+MO:hover {
    transform: scale(0.95) !important;
  }
  
  .styles_tituloPopup__jkjUc {
    font-size: 28px !important;
    color: #0f2047 !important;
    font-family: "Abhaya Libre" !important;
    margin: 8px;
  }
  
  .styles_tituloPopupContainer__owz49 {
    display: flex !important;
    align-items: center !important;
  }
  
  .styles_botaoPopupSalvar__0HKkt {
    width: 180px !important;
    background-color: #0f2047 !important;
    color: #ffffff !important;
    border-color: #ffffff !important;
    border-width: 1px !important;
    border-style: solid !important;
    font-family: "Inter" !important;
    border-radius: 8px !important;
    transition: all 0.3s ease !important;
  }
  
  .styles_botaoPopupSalvar__0HKkt:hover {
    transform: scale(0.95) !important;
  }
  
  .styles_botaoPopupCancelar__-dpxJ {
    width: 180px !important;
    background-color: #ffffff !important;
    color: #0f2047 !important;
    border-color: #0f2047 !important;
    border-width: 1px !important;
    border-style: solid !important;
    font-family: "Inter" !important;
    border-radius: 8px !important;
    transition: all 0.3s ease !important;
    font-weight: 600 !important;
  }
  
  .styles_botaoPopupCancelar__-dpxJ:hover {
    transform: scale(0.95) !important;
  }
  
  .styles_txtBuscaTabela__BrS6A {
    margin-top: 16px !important;
    margin-left: 16px !important;
  }
  
  .styles_iconeBusca__CnOGv {
    color: #18316e !important;
    font-size: 28px !important;
    margin-top: 16px !important;
  }
  
  .styles_iconeTabela__KXIHl {
    color: #0f2047 !important;
    font-size: 28px !important;
    padding: 4px !important;
  }
  
  .styles_textoExclusao__MhWAO {
    color: #000000 !important;
    font-family: "Inter" !important;
    font-size: 16px !important;
  }
  
  .styles_tituloExclusao__xALCJ {
    color: #0f2047 !important;
    font-family: "Abhaya Libre" !important;
    font-size: 44px !important;
  }
  
  .styles_botaoPopupExcluir__33nxX {
    width: 120px !important;
    background-color: #0f2047 !important;
    color: #ffffff !important;
    border-color: #ffffff !important;
    border-width: 1px !important;
    border-style: solid !important;
    font-family: "Inter" !important;
    border-radius: 8px !important;
    transition: all 0.3s ease !important;
    margin-right: 7%;
    margin-bottom: 4%;
  }
  
  .styles_botaoPopupExcluir__33nxX:hover {
    transform: scale(0.95) !important;
  }
  
  .styles_botaoPopupCancelarExclusao__9WIbY {
    width: 120px !important;
    background-color: #ffffff !important;
    color: #0f2047 !important;
    border-color: #0f2047 !important;
    border-width: 1px !important;
    border-style: solid !important;
    font-family: "Inter" !important;
    border-radius: 8px !important;
    transition: all 0.3s ease !important;
    font-weight: 600 !important;
    margin-right: 4%;
    margin-bottom: 4%;
  }
  
  .styles_botaoPopupCancelarExclusao__9WIbY:hover {
    transform: scale(0.95) !important;
  }
  
  /* Adicione este trecho de código ao seu arquivo de estilos CSS (por exemplo, styles.module.css) */
  
  .styles_caixaTextoPequena__sxBfi {
    height: 28px;
    /* Ajuste a altura conforme necessário */
  }
  
  .styles_caixaDeTexto__ZdWGS {
    margin: 200px 70 !important;
    height: 30px !important;
  }
  
  .styles_botaoVoltar__iZMxD {
    background-color: #0f2047;
    color: #ffffff;
    border-color: #ffffff;
    border-width: 1px;
    border-style: solid;
    font-family: "Inter";
    border-radius: 8px;
    transition: all 0.3s ease;
    text-transform: capitalize;
    height: 36px;
  }
  
  .styles_botaoVoltar__iZMxD:hover {
    background-color: #ffffff;
    color: #0f2047;
  }
  
  .styles_inputPequeno__Jacdh {
    width: 100%;
    padding: 5px;
    box-sizing: border-box;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
    /* Adicione mais estilos conforme necessário */
  }
  
  .styles_botaoVoltar__iZMxD:hover {
    background-color: #0f2047;
    color: #ffffff;
  }
  
  .styles_labelPequeno__NLtHI {
    font-size: 12px;
    /* Ajuste o valor conforme necessário */
  }
  
  .styles_placeholder__Z1D3C {
    font-size: 12px;
    /* Ajuste o valor conforme necessário */
    /* Outros estilos do placeholder, se necessário */
  }
  
  .styles_popupHeader__7uGTN {
    padding-bottom: 0px !important;
  }
  
  .styles_popupContent__-tLCz {
    padding-top: 0px;
  }

  .styles_selectContainer__t-gGF{
    align-items: center;
    background: #ffffff;
    display: flex;
    justify-content: flex-end;
    margin: -2.5rem 2.5rem 0rem 2.5rem;
    padding: 0 1rem 2.1rem 0; 
  }

  .styles_iconSearch__jL6Ok{
    color: #18316e !important;
    font-size: 1.8rem !important;
    margin-right: .5rem !important;
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/AjustesVerbas/styles.module.css"],"names":[],"mappings":"AAAA;IACI,8CAA8C;IAC9C,4BAA4B;IAC5B,sBAAsB;IACtB,4BAA4B;EAC9B;;EAEA;IACE,8CAA8C;IAC9C,4BAA4B;IAC5B,sBAAsB;IACtB,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,4BAA4B;IAC5B,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;IAC1B,yBAAyB;IACzB,sCAAsC;EACxC;;EAEA;IACE,0BAA0B;IAC1B,yBAAyB;IACzB,4BAA4B;IAC5B,6BAA6B;IAC7B,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;IAC1B,yBAAyB;IACzB,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;IACvB,oCAAoC;IACpC,yBAAyB;IACzB,gCAAgC;IAChC,4BAA4B;IAC5B,8BAA8B;IAC9B,+BAA+B;IAC/B,0BAA0B;IAC1B,2BAA2B;IAC3B,2BAA2B;IAC3B,6BAA6B;IAC7B,oCAAoC;IACpC,qCAAqC;IACrC,uBAAuB;EACzB;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,0BAA0B;IAC1B,yBAAyB;IACzB,sCAAsC;IACtC,WAAW;EACb;;EAEA;IACE,wBAAwB;IACxB,8BAA8B;EAChC;;EAEA;IACE,uBAAuB;IACvB,oCAAoC;IACpC,yBAAyB;IACzB,gCAAgC;IAChC,4BAA4B;IAC5B,8BAA8B;IAC9B,+BAA+B;IAC/B,6BAA6B;IAC7B,oCAAoC;EACtC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,uBAAuB;IACvB,oCAAoC;IACpC,yBAAyB;IACzB,gCAAgC;IAChC,4BAA4B;IAC5B,8BAA8B;IAC9B,+BAA+B;IAC/B,6BAA6B;IAC7B,oCAAoC;IACpC,2BAA2B;EAC7B;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,yBAAyB;IACzB,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;IACzB,0BAA0B;IAC1B,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;IACzB,+BAA+B;IAC/B,0BAA0B;EAC5B;;EAEA;IACE,yBAAyB;IACzB,sCAAsC;IACtC,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;IACvB,oCAAoC;IACpC,yBAAyB;IACzB,gCAAgC;IAChC,4BAA4B;IAC5B,8BAA8B;IAC9B,+BAA+B;IAC/B,6BAA6B;IAC7B,oCAAoC;IACpC,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,uBAAuB;IACvB,oCAAoC;IACpC,yBAAyB;IACzB,gCAAgC;IAChC,4BAA4B;IAC5B,8BAA8B;IAC9B,+BAA+B;IAC/B,6BAA6B;IAC7B,oCAAoC;IACpC,2BAA2B;IAC3B,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,iCAAiC;EACnC;;EAEA,kGAAkG;;EAElG;IACE,YAAY;IACZ,wCAAwC;EAC1C;;EAEA;IACE,2BAA2B;IAC3B,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,yBAAyB;IACzB,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,8CAA8C;EAChD;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,uCAAuC;EACzC;;EAEA;IACE,eAAe;IACf,uCAAuC;IACvC,iDAAiD;EACnD;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,kCAAkC;IAClC,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;IACzB,4BAA4B;IAC5B,8BAA8B;EAChC","sourcesContent":[".linhaTitulo {\n    border-bottom: 0.1rem solid #0f2047 !important;\n    margin-left: 40px !important;\n    width: 80px !important;\n    margin-top: -16px !important;\n  }\n  \n  .linhaTituloPopup {\n    border-bottom: 0.2rem solid #0f2047 !important;\n    margin-left: 40px !important;\n    width: 80px !important;\n    margin-top: 0px !important;\n    padding-top: 0px !important;\n  }\n  \n  .tituloContainer {\n    display: flex !important;\n    align-items: center !important;\n    margin-left: 40px !important;\n    margin-top: -28px !important;\n  }\n  \n  .titulo {\n    font-size: 44px !important;\n    color: #0f2047 !important;\n    font-family: \"Abhaya Libre\" !important;\n  }\n  \n  .iconeTitulo {\n    font-size: 40px !important;\n    color: #0f2047 !important;\n    margin-left: 12px !important;\n    margin-right: 12px !important;\n    margin-top: -8px !important;\n  }\n  \n  .iconeTituloPopup {\n    font-size: 40px !important;\n    color: #0f2047 !important;\n    margin-top: -8px !important;\n  }\n  \n  .botaoContainer {\n    display: flex !important;\n    align-items: center !important;\n    margin-left: 40px !important;\n  }\n  \n  .botaoNovo {\n    width: 120px !important;\n    background-color: #0f2047 !important;\n    color: #ffffff !important;\n    border-color: #ffffff !important;\n    border-width: 1px !important;\n    border-style: solid !important;\n    font-family: \"Inter\" !important;\n    font-size: 16px !important;\n    margin-top: 12px !important;\n    margin-left: 20% !important;\n    border-radius: 8px !important;\n    transition: all 0.3s ease !important;\n    text-transform: capitalize !important;\n    height: 36px !important;\n  }\n  \n  .botaoNovo:hover {\n    transform: scale(0.95) !important;\n  }\n  \n  .tituloPopup {\n    font-size: 28px !important;\n    color: #0f2047 !important;\n    font-family: \"Abhaya Libre\" !important;\n    margin: 8px;\n  }\n  \n  .tituloPopupContainer {\n    display: flex !important;\n    align-items: center !important;\n  }\n  \n  .botaoPopupSalvar {\n    width: 180px !important;\n    background-color: #0f2047 !important;\n    color: #ffffff !important;\n    border-color: #ffffff !important;\n    border-width: 1px !important;\n    border-style: solid !important;\n    font-family: \"Inter\" !important;\n    border-radius: 8px !important;\n    transition: all 0.3s ease !important;\n  }\n  \n  .botaoPopupSalvar:hover {\n    transform: scale(0.95) !important;\n  }\n  \n  .botaoPopupCancelar {\n    width: 180px !important;\n    background-color: #ffffff !important;\n    color: #0f2047 !important;\n    border-color: #0f2047 !important;\n    border-width: 1px !important;\n    border-style: solid !important;\n    font-family: \"Inter\" !important;\n    border-radius: 8px !important;\n    transition: all 0.3s ease !important;\n    font-weight: 600 !important;\n  }\n  \n  .botaoPopupCancelar:hover {\n    transform: scale(0.95) !important;\n  }\n  \n  .txtBuscaTabela {\n    margin-top: 16px !important;\n    margin-left: 16px !important;\n  }\n  \n  .iconeBusca {\n    color: #18316e !important;\n    font-size: 28px !important;\n    margin-top: 16px !important;\n  }\n  \n  .iconeTabela {\n    color: #0f2047 !important;\n    font-size: 28px !important;\n    padding: 4px !important;\n  }\n  \n  .textoExclusao {\n    color: #000000 !important;\n    font-family: \"Inter\" !important;\n    font-size: 16px !important;\n  }\n  \n  .tituloExclusao {\n    color: #0f2047 !important;\n    font-family: \"Abhaya Libre\" !important;\n    font-size: 44px !important;\n  }\n  \n  .botaoPopupExcluir {\n    width: 120px !important;\n    background-color: #0f2047 !important;\n    color: #ffffff !important;\n    border-color: #ffffff !important;\n    border-width: 1px !important;\n    border-style: solid !important;\n    font-family: \"Inter\" !important;\n    border-radius: 8px !important;\n    transition: all 0.3s ease !important;\n    margin-right: 7%;\n    margin-bottom: 4%;\n  }\n  \n  .botaoPopupExcluir:hover {\n    transform: scale(0.95) !important;\n  }\n  \n  .botaoPopupCancelarExclusao {\n    width: 120px !important;\n    background-color: #ffffff !important;\n    color: #0f2047 !important;\n    border-color: #0f2047 !important;\n    border-width: 1px !important;\n    border-style: solid !important;\n    font-family: \"Inter\" !important;\n    border-radius: 8px !important;\n    transition: all 0.3s ease !important;\n    font-weight: 600 !important;\n    margin-right: 4%;\n    margin-bottom: 4%;\n  }\n  \n  .botaoPopupCancelarExclusao:hover {\n    transform: scale(0.95) !important;\n  }\n  \n  /* Adicione este trecho de código ao seu arquivo de estilos CSS (por exemplo, styles.module.css) */\n  \n  .caixaTextoPequena {\n    height: 28px;\n    /* Ajuste a altura conforme necessário */\n  }\n  \n  .caixaDeTexto {\n    margin: 200px 70 !important;\n    height: 30px !important;\n  }\n  \n  .botaoVoltar {\n    background-color: #0f2047;\n    color: #ffffff;\n    border-color: #ffffff;\n    border-width: 1px;\n    border-style: solid;\n    font-family: \"Inter\";\n    border-radius: 8px;\n    transition: all 0.3s ease;\n    text-transform: capitalize;\n    height: 36px;\n  }\n  \n  .botaoVoltar:hover {\n    background-color: #ffffff;\n    color: #0f2047;\n  }\n  \n  .inputPequeno {\n    width: 100%;\n    padding: 5px;\n    box-sizing: border-box;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    font-size: 14px;\n    /* Adicione mais estilos conforme necessário */\n  }\n  \n  .botaoVoltar:hover {\n    background-color: #0f2047;\n    color: #ffffff;\n  }\n  \n  .labelPequeno {\n    font-size: 12px;\n    /* Ajuste o valor conforme necessário */\n  }\n  \n  .placeholder {\n    font-size: 12px;\n    /* Ajuste o valor conforme necessário */\n    /* Outros estilos do placeholder, se necessário */\n  }\n  \n  .popupHeader {\n    padding-bottom: 0px !important;\n  }\n  \n  .popupContent {\n    padding-top: 0px;\n  }\n\n  .selectContainer{\n    align-items: center;\n    background: #ffffff;\n    display: flex;\n    justify-content: flex-end;\n    margin: -2.5rem 2.5rem 0rem 2.5rem;\n    padding: 0 1rem 2.1rem 0; \n  }\n\n  .iconSearch{\n    color: #18316e !important;\n    font-size: 1.8rem !important;\n    margin-right: .5rem !important;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"linhaTitulo": `styles_linhaTitulo__Hp35d`,
	"linhaTituloPopup": `styles_linhaTituloPopup__pk1Za`,
	"tituloContainer": `styles_tituloContainer__DDrMr`,
	"titulo": `styles_titulo__KESZq`,
	"iconeTitulo": `styles_iconeTitulo__T4EYK`,
	"iconeTituloPopup": `styles_iconeTituloPopup__g0LKR`,
	"botaoContainer": `styles_botaoContainer__NX6Tk`,
	"botaoNovo": `styles_botaoNovo__j3+MO`,
	"tituloPopup": `styles_tituloPopup__jkjUc`,
	"tituloPopupContainer": `styles_tituloPopupContainer__owz49`,
	"botaoPopupSalvar": `styles_botaoPopupSalvar__0HKkt`,
	"botaoPopupCancelar": `styles_botaoPopupCancelar__-dpxJ`,
	"txtBuscaTabela": `styles_txtBuscaTabela__BrS6A`,
	"iconeBusca": `styles_iconeBusca__CnOGv`,
	"iconeTabela": `styles_iconeTabela__KXIHl`,
	"textoExclusao": `styles_textoExclusao__MhWAO`,
	"tituloExclusao": `styles_tituloExclusao__xALCJ`,
	"botaoPopupExcluir": `styles_botaoPopupExcluir__33nxX`,
	"botaoPopupCancelarExclusao": `styles_botaoPopupCancelarExclusao__9WIbY`,
	"caixaTextoPequena": `styles_caixaTextoPequena__sxBfi`,
	"caixaDeTexto": `styles_caixaDeTexto__ZdWGS`,
	"botaoVoltar": `styles_botaoVoltar__iZMxD`,
	"inputPequeno": `styles_inputPequeno__Jacdh`,
	"labelPequeno": `styles_labelPequeno__NLtHI`,
	"placeholder": `styles_placeholder__Z1D3C`,
	"popupHeader": `styles_popupHeader__7uGTN`,
	"popupContent": `styles_popupContent__-tLCz`,
	"selectContainer": `styles_selectContainer__t-gGF`,
	"iconSearch": `styles_iconSearch__jL6Ok`
};
export default ___CSS_LOADER_EXPORT___;
